import { CalendarBlankIcon, MapPinIcon } from "@phosphor-icons/react";
import { Trans, useTranslation } from "react-i18next";
import { Button } from "@/core/shared/v2/ui/button";
import { IntersectionFadeIn } from "@/core/shared/v2/ui/intersection-fade-in";
import { Layout } from "../layout";
import { HeroLayout } from "./hero-layout";

type HeroSectionProps = {
  address: string;
  dateRange: string;
  onClick: () => void;
};

const SignUpButton = ({ onClick }: Pick<HeroSectionProps, "onClick">) => {
  const { t } = useTranslation();
  return (
    <Button variant="primary" size="xl" className="w-full sm:w-auto" onClick={onClick}>
      {t("GROUP_ACTIONS_ORDERING.HERO.SIGN_UP")}
    </Button>
  );
};

export const HeroSection = ({ address, dateRange, onClick }: HeroSectionProps) => {
  const { t } = useTranslation();

  return (
    <HeroLayout>
      <Layout className="relative z-20 md:pt-28">
        <IntersectionFadeIn>
          <div className="mb-10">
            <h1 className="!leading-tight max-w-[670px] text-pretty text-center font-heading font-serif text-3xl md:text-left md:text-5xl">
              <Trans i18nKey="cmsTranslations.homepage.title" />
            </h1>
            <p className="mt-4 max-w-[700px] text-pretty text-base md:text-lg">
              {t("cmsTranslations.homepage.description")}
            </p>
            <div className="mt-8 hidden md:block">
              <SignUpButton onClick={onClick} />
            </div>
          </div>
          <div className="flex flex-col gap-10 md:flex-row md:items-center">
            <div className="flex gap-x-4">
              <MapPinIcon className="mt-0.5 size-6 text-black" />
              <div className="flex flex-col gap-y-2.5">
                <span className="font-semibold text-sm">{t("GROUP_ACTIONS_ORDERING.HERO.ADDRESS")}</span>
                <span>{address}</span>
              </div>
            </div>
            <div className="flex gap-x-4">
              <CalendarBlankIcon className="mt-0.5 size-6 text-black" />
              <div className="flex flex-col gap-y-2.5">
                <span className="font-semibold text-sm">{t("GROUP_ACTIONS_ORDERING.HERO.DATE")}</span>
                <span>{dateRange}</span>
              </div>
            </div>
          </div>
          <div className="mt-10 block md:hidden">
            <SignUpButton onClick={onClick} />
          </div>
        </IntersectionFadeIn>
      </Layout>
    </HeroLayout>
  );
};
